import { render, staticRenderFns } from "./HomeList.vue?vue&type=template&id=2e7650f6&"
import script from "./HomeList.vue?vue&type=script&lang=js&"
export * from "./HomeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports